import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=26d437ff&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=26d437ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d437ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d437ff')) {
      api.createRecord('26d437ff', component.options)
    } else {
      api.reload('26d437ff', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=26d437ff&scoped=true&", function () {
      api.rerender('26d437ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sN1jSJLlG1Wi/JS/comp/GuestBox.vue"
export default component.exports